"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxyLogForDevice = exports.Mezmo = exports.MEZMO_HEADERS = exports.MEZMO_URL = void 0;
const Log_1 = require("./Log");
exports.MEZMO_URL = "https://logs.logdna.com/logs/ingest?hostname=";
exports.MEZMO_HEADERS = {
    "Content-Type": "application/json; charset=UTF-8",
    "Authorization": "Basic MmJmMzgzMTdmYzczYmE4ODQ1YzBkMTA5ZWZiOGEzMzI6",
};
const PROXY_APP_NAME = "proxy";
class Mezmoer {
}
_a = Mezmoer;
Mezmoer.SEND_INTERVAL_MS = 30 * 1000;
Mezmoer.logHolder = {};
Mezmoer.addLog = (logLevel, message, meta, opts) => {
    if (Mezmoer.interval === undefined) {
        Mezmoer.interval = setInterval(() => {
            Mezmoer.ship();
        }, Mezmoer.SEND_INTERVAL_MS);
    }
    const url = opts ? exports.MEZMO_URL + opts.customId : exports.MEZMO_URL + Log_1.Log.profileUUID;
    if (Mezmoer.logHolder[url] === undefined) {
        Mezmoer.logHolder[url] = [];
    }
    let appName = "Unknown App";
    if (opts) {
        appName = opts.appName;
    }
    else if (typeof Log_1.Log.appName === "undefined") {
        appName = Log_1.Log.appName;
    }
    Mezmoer.logHolder[url].push({
        timestamp: Date.now(),
        line: message,
        app: appName,
        meta: Object.assign(Object.assign({}, Log_1.Log.extraData), { data: meta }),
        level: logLevel,
    });
};
Mezmoer.ship = () => __awaiter(void 0, void 0, void 0, function* () {
    for (const url of Object.keys(Mezmoer.logHolder)) {
        const logs = Mezmoer.logHolder[url];
        if (logs.length > 0) {
            const body = JSON.stringify({
                lines: logs,
            });
            try {
                const requestOptions = {
                    method: "POST",
                    headers: exports.MEZMO_HEADERS,
                    body: body,
                };
                const response = yield fetch(url, requestOptions);
                if (!response.ok) {
                    console.log(`FAILED TO SEND TO MEZMO:${JSON.stringify(response)}`);
                }
                else {
                    Mezmoer.logHolder[url] = [];
                }
            }
            catch (e) {
            }
        }
    }
});
function Mezmo(logLevel, message, meta, opts) {
    Mezmoer.addLog(logLevel, message, meta, opts);
}
exports.Mezmo = Mezmo;
const proxyLogForDevice = (logLevel, id, message) => __awaiter(void 0, void 0, void 0, function* () { return Mezmo(logLevel, message, undefined, { customId: id, appName: PROXY_APP_NAME }); });
exports.proxyLogForDevice = proxyLogForDevice;
//# sourceMappingURL=Mezmo.js.map